import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "../confirm-dialog/confirm-dialog";
/**
 * Reusable confirmation dialog for unsaved form changes.
 *
 * @example
 * ```tsx
 * <UnsavedChangesConfirmDialog
 *   open={showCloseConfirmation}
 *   onStay={handleStay}
 *   onDiscard={handleDiscardChanges}
 * />
 * ```
 */ export function UnsavedChangesConfirmDialog({ open, onStay, onDiscard }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(ConfirmDialog, {
        open: open,
        onOpenChange: (next)=>{
            if (!next) onStay();
        },
        title: t("common.unsavedChanges"),
        description: t("common.unsavedChangesDescription"),
        cancelLabel: t("common.stay"),
        confirmLabel: t("common.discardChanges"),
        variant: "danger",
        onConfirm: onDiscard,
        onCancel: onStay
    });
}

//# sourceMappingURL=unsaved-changes-confirm-dialog.js.map